import {
  ActivityFeedPayload,
  ActivityFeedRow,
  ActivityTimeline,
  ActivityTimelinePayload,
  ActivityCountResults,
  ActivityCountsPayload,
  LeaderboardRow,
  ActivityFeedExport,
  ActivityFeedExportParams,
} from 'src/@types/reports';
import { useGet } from './templateHooks';
import { useAxios } from './useFetch';
import { useMutation } from '@tanstack/react-query';
import { LeaderboardPayload } from '../../@types/reports';
import { FAST_API_URL } from 'src/config';

export const useActivityFeed = (params: ActivityFeedPayload, config = {}) =>
  useGet<ActivityFeedRow[], ActivityFeedPayload>({
    queryKey: ['activityFeed', params],
    endpoint: '/v1/activity-feed',
    config: config,
    params: params,
    url: FAST_API_URL,
  });

export const useVoterActivityFeed = (voterId: string, config = {}) =>
  useGet<ActivityFeedRow[], ActivityFeedPayload>({
    queryKey: ['activityFeed', voterId],
    endpoint: `/v1/voters/${voterId}/interactions`,
    config: config,
    url: FAST_API_URL,
  });

export const useCreateActivityFeedExport = () => {
  const mutationFn = useAxios<ActivityFeedExport, ActivityFeedExportParams>({
    endpoint: '/v1/activity-feed-exports',
    method: 'post',
    url: FAST_API_URL,
  });
  return useMutation({
    mutationFn: (data: ActivityFeedExportParams) => mutationFn({ data }),
  });
};

export const useLeaderboard = (params: LeaderboardPayload, config = {}) =>
  useGet<LeaderboardRow[], LeaderboardPayload>({
    queryKey: ['leaderboard', params],
    endpoint: '/v1/leaderboard',
    config: config,
    params: params,
    url: FAST_API_URL,
  });

export const useActivityTimestamps = (params: ActivityTimelinePayload, config = {}) =>
  useGet<ActivityTimeline, ActivityTimelinePayload>({
    queryKey: ['activityTimestamps', params],
    endpoint: '/v1/interactions/counts/timestamps',
    config: config,
    params: params,
    url: FAST_API_URL,
  });

export const useActivityCounts = (params: ActivityCountsPayload, config = {}) =>
  useGet<ActivityCountResults, ActivityCountsPayload>({
    queryKey: ['activityCounts', params],
    endpoint: '/v1/activity-counts',
    config: config,
    params: params,
    url: FAST_API_URL,
  });

export const useCampaignActivityTimestamps = (params: ActivityTimelinePayload, config = {}) =>
  useGet<ActivityTimeline, ActivityTimelinePayload>({
    queryKey: ['campaignActivityTimestamps', params],
    endpoint: '/v1/interactions/campaigns/timestamps',
    config: config,
    params: params,
    url: FAST_API_URL,
  });

export const useCampaignLeaderboard = (params: LeaderboardPayload, config = {}) =>
  useGet<LeaderboardRow[], LeaderboardPayload>({
    queryKey: ['campaignLeaderboard', params],
    endpoint: '/v1/campaigns/leaderboard',
    config: config,
    params: params,
    url: FAST_API_URL,
  });
